import TradeshowGrid from "../../components/tradeshowGrid";

function Events() {
  return (
    <div className="events-page">
      <h1>Trade Shows & Events</h1>
      <TradeshowGrid />
    </div>
  );
}

export default Events;